import { Link, useHistory } from 'react-router-dom';
import { trackLinkClick } from '../../common/analytics';
import Button from '../../common/components/button';
import Div from '../../common/components/div';
import H1 from '../../common/components/h1';
import StackingButtons from '../../common/components/StackingButtons';
import TranslatedSpan from '../../common/components/TranslatedSpan';
import translate from '../../common/functions/translate';

interface NoRecordFoundInfoProps {
   parentName: string
}
export default function NoAccountInRecords(props: NoRecordFoundInfoProps) {
    const history = useHistory();

    const getCreateAccountButton = () => {
        return <>
            <Button
                variation={'solid'}
                mfaAnalyticsData={{
                    text: props.parentName,
                    parentComponentHeading: props.parentName
                }}
                onClick={() => history.push('/create-account')}
            >
                <TranslatedSpan english={'create_account'}/>
            </Button>
        </>;
    };

    const getGoToMedicareDotGovButton = () => {
        return <>
            <Button
                onClick={() => document.location.href = "https://www.medicare.gov"}
            >
                <TranslatedSpan english={'go_to_medicaregov'}/>
            </Button>
        </>;
    };

    return (
        <Div
            isContainer={true}
            paddingySM={1} paddingyMD={2} paddingyLG={3} paddingyXL={4}>
            <Div isRow>
                <Div cols={12}>
                    <H1 className='ds-u-padding-bottom--3'>
                        <TranslatedSpan english={'no_account_in_our_records'}/>
                    </H1>
                </Div>
            </Div>
            <Div isRow>
                <Div cols={12} colsMD={8}>
                    {`${translate('you_dont_have_account_yet')} `}
                    <Link
                        to="/create-account"
                        onClick={trackLinkClick(translate('find_my_account'))}
                    >
                        {translate('create_one')}
                    </Link>
                    {` ${translate('for_more_personalized_experience')}`}
                </Div>
            </Div>
            <StackingButtons
                button1={getCreateAccountButton()}
                button2={getGoToMedicareDotGovButton()}
            />
        </Div>
    );
}
